export const LOCAL_MODE = false;
export const TEST_MODE = false;
export const API_URL = LOCAL_MODE ? "http://127.0.0.1:8000/api/" : (TEST_MODE ? "https://test-api.rairer.com/api/" : "https://api.rairer.com/api/");
export const FB_APP_ID = process.env.REACT_APP_FB_APP_ID;
export const FB_APP_VERSION = "v22.0";